import { useState, useEffect, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { resourceService } from '../services/resourceService'
import type { Resource } from '../types'

interface UseResourcesState {
  resources: Resource[]
  isLoading: boolean
  error: string | null
}

export function useResources(category: string, type?: string) {
  const { i18n } = useTranslation()
  const language = i18n.language

  const [state, setState] = useState<UseResourcesState>({
    resources: [],
    isLoading: false,
    error: null,
  })

  const load = useCallback(async () => {
    if (!category) return

    setState(s => ({ ...s, isLoading: true, error: null }))
    try {
      const resources = await resourceService.getByCategory(category, type)
      setState({ resources, isLoading: false, error: null })
    } catch {
      setState({ resources: [], isLoading: false, error: 'No se pudo cargar el catálogo de recursos.' })
    }
  }, [category, type, language])

  useEffect(() => {
    load()
  }, [load])

  return { ...state, reload: load }
}
